module.exports = __webpack_public_path__ + "static/img/2_06.554f6252.jpg";